import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-outlined p-4"
}
const _hoisted_2 = { class: "text-subtitle" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = { for: "status2" }
const _hoisted_5 = { for: "status3" }
const _hoisted_6 = { class: "form-error-text" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = {
  for: "name",
  class: "form-label"
}
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "form-error-text" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = {
  for: "email",
  class: "form-label"
}
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "form-error-text" }
const _hoisted_15 = { class: "pt-4 pb-2 flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_alert = _resolveComponent("base-alert")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!

  return (_ctx.seminarDetails)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_alert, { class: "mb-4" }),
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.t('seminar_details.apply.title')), 1),
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
        }, [
          (_ctx.seminarStatus && _ctx.seminarDetails.seminar_category_id === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "status2",
                    value: 2,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.seminar_status_id) = $event)),
                    class: "mr-2"
                  }, null, 512), [
                    [_vModelRadio, _ctx.seminar_status_id]
                  ]),
                  _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.findStatusNameById(2)), 1)
                ]),
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "status3",
                    value: 3,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.seminar_status_id) = $event)),
                    class: "mr-2"
                  }, null, 512), [
                    [_vModelRadio, _ctx.seminar_status_id]
                  ]),
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.findStatusNameById(3)), 1)
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errors['name']), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t('word.name')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event)),
              id: "name",
              name: "name",
              type: "text",
              placeholder: _ctx.t('word.name'),
              class: _normalizeClass(`form-input mb-1 ${_ctx.errors['name'] ? 'border-red-500' : ''}`)
            }, null, 10, _hoisted_9), [
              [_vModelText, _ctx.name]
            ]),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.errors['name']), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t('word.email')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
              id: "email",
              name: "email",
              type: "email",
              placeholder: _ctx.t('word.email'),
              class: _normalizeClass(`form-input mb-1 ${_ctx.errors['email'] ? 'border-red-500' : ''}`)
            }, null, 10, _hoisted_13), [
              [_vModelText, _ctx.email]
            ]),
            _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.errors['email']), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_base_form_submit, {
              disabled: _ctx.btnDisabled,
              text: _ctx.t('seminar_details.apply.submit')
            }, null, 8, ["disabled", "text"])
          ])
        ], 32)
      ]))
    : _createCommentVNode("", true)
}